<template>
	<div class="map-bg bg-green-800 min-h-screen h-full w-full">
        <div class="w-screen h-screen bg-grey-700 opacity-25 absolute top-0 left-0"></div>
		<div style="position: relative; z-index: 1;">
			<div class="gradient-bg px-4 md:px-10 lg:px-32 xl:px-64 pt-6 pb-8">
				<h1 class="title text-white text-6xl sm:text-7xl md:text-8xl">LOST IN THE CITY</h1>
			</div>
			
			<div v-if="body != 'coming_soon'" class="fixed bottom-0 left-0 w-full bottom-shadow">
				<error class="px-4 md:px-10 lg:px-32 xl:px-64" colour="red" icon="triangle_error" :title="title" :body="body" />
			</div>
			
			<div v-if="body == 'coming_soon'" class="fixed bottom-0 left-0 w-full px-5 md:px-10 lg:px-32 xl:px-64 py-4">
				<h2 class="font-sans text-white text-8xl m-0 leading-none coming_soon-title">Coming soon.</h2>
			</div>
		</div>
	</div>
</template>

<style>
.gradient-bg {
	background: rgb(50,63,67);
	background: linear-gradient(180deg, rgba(50,63,67,1) 0%, rgba(50,63,67,1) 55%, rgba(50,63,67,0) 97%, rgba(50,63,67,0) 100%);
}
.title {
	line-height: 0.9;
	text-shadow: 0 3px 25px rgba(70, 83, 87, 0.6);
}
.bottom-shadow {
	box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.45);
}
.coming_soon-title {
    text-shadow: 0 2px 20px rgba(0, 0, 0, 0.5),
                 0 2px 40px rgba(0, 0, 0, 0.3);
}
</style>

<script>
import Storages from 'js-storage';
import ErrorBox from '../components/ErrorBox.vue';

export default {
	name: 'Maintenance',
	path: '/maintenance',
	components: {
		'error': ErrorBox
	},
	data() {
		return {
            storage: null,
			title: "Under maintenance",
            body: "",
            online_config: {},
            maintenance: null
		}
	},
	created() {
        this.storage = Storages.localStorage;
        this.online_config = this.storage.get('online_config');
        this.maintenance = this.online_config.maintenance;

        if (this.maintenance == false) {
            this.$router.replace("/");
        } else {
            this.body = this.maintenance;
        }
	}
}
</script>
